import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { MY_ACCOUNT_DATE_FORMAT } from 'constants/appConstants';

import MartyLink from 'components/common/MartyLink';
import MelodyCarousel from 'components/common/MelodyCarousel';
import OrderStatus from 'components/account/OrderStatus';
import OrderItemImage from 'components/account/OrderItemImage';
import styles from 'styles/components/account/orderHistoryCard.scss';

const OrderHistoryCard = ({ order }, { testId }) => {
  const { orderId, orderDate, lineItems, pricing } = order;

  return (
    <li role="menuitem" className={styles.orderHistoryCard}>
      <div className={styles.cardHeader}>
        <div>
          <span className={styles.orderDate} data-test-id={testId('orderDate')}>
            {moment(orderDate, MY_ACCOUNT_DATE_FORMAT).format('ll')}
          </span>
          <span>
            <OrderStatus order={order}/>
          </span>
        </div>
        <div className={styles.orderIdRow}>
          <span data-test-id={testId('orderNumber')}>#{orderId}</span>
        </div>
        <div>
          {pricing && (
            <span className={styles.orderPrice} data-test-id={testId('totalCharged')}>
              {pricing.totalCharged}
            </span>
          )}
        </div>
      </div>
      <div className={styles.melodyCarousel}>
        <MelodyCarousel>
          {lineItems.map(({ product }, index) => {
            const { retinaImageUrl, name } = product;
            return (
              <OrderItemImage
                key={index}
                title={name}
                imageUrl={retinaImageUrl}
                url={`/orders/${orderId}`}/>
            );
          })}
        </MelodyCarousel>
      </div>
      <div className={styles.cardAction}>
        <MartyLink to={`/orders/${orderId}`} data-test-id={testId('orderLink')}>View Order Details</MartyLink>
      </div>
    </li>
  );
};

OrderHistoryCard.contextTypes = {
  testId: PropTypes.func
};

OrderHistoryCard.propTypes = {
  order: PropTypes.object.isRequired
};

export default OrderHistoryCard;
